import React from 'react';
import { Btn, Eyebrow } from '../design-system';
import './hero.css';

interface HeroProps {
  eyebrow: string;
  title: React.ReactNode;
  lede?: React.ReactNode;
  primaryCta?: { label: React.ReactNode; to?: string; onClick?: () => void };
  secondaryCta?: { label: React.ReactNode; to?: string; onClick?: () => void };
  metrics?: { value: string; label: string }[];
  narrow?: boolean;
}

const Hero: React.FC<HeroProps> = ({
  eyebrow,
  title,
  lede,
  primaryCta,
  secondaryCta,
  metrics,
  narrow,
}) => (
  <section className="hero">
    <div className="ds-wrap">
      <div className={narrow ? 'hero__copy hero__copy--narrow' : 'hero__copy'}>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1>{title}</h1>
        {lede && <p className="hero__lede">{lede}</p>}
        {(primaryCta || secondaryCta) && (
          <div className="hero__cta">
            {primaryCta && (primaryCta.to ? (
              <Btn variant="primary" to={primaryCta.to}>
                {primaryCta.label}
                <svg viewBox="0 0 12 12" width={12} height={12} fill="none" stroke="currentColor" strokeWidth={1.5}>
                  <path d="M2 6h8M7 3l3 3-3 3" />
                </svg>
              </Btn>
            ) : (
              <Btn variant="primary" onClick={primaryCta.onClick}>
                {primaryCta.label}
              </Btn>
            ))}
            {secondaryCta && (secondaryCta.to ? (
              <Btn variant="ghost" to={secondaryCta.to}>
                {secondaryCta.label}
              </Btn>
            ) : (
              <Btn variant="ghost" onClick={secondaryCta.onClick}>
                {secondaryCta.label}
              </Btn>
            ))}
          </div>
        )}
        {metrics && metrics.length > 0 && (
          <div className="hero__meta">
            {metrics.map(m => (
              <div key={m.label}>
                <b>{m.value}</b>
                {m.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  </section>
);

export default Hero;
